module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/alana-image-43f34bd2027865e726da4b56961c0c2a.jpg";